import script from "./SimpleChatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleChatPage.vue?vue&type=script&setup=true&lang=js"

import "./SimpleChatPage.vue?vue&type=style&index=0&id=42f9d106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f9d106"]])

export default __exports__